import { EMU_SERIAL_COL, STANDARD_COLS } from '../genericTableColumns';
import { addBaseProperties } from '../mappers';
import { ACTIVITY_TABLE_HEADERS } from './activities';
export const EMU_ION_FILTER_TABLE_HEADERS = [...STANDARD_COLS];
export const ACTIVITY_EMU_ION_FILTER_TABLE_HEADERS = [...ACTIVITY_TABLE_HEADERS, EMU_SERIAL_COL];
export const transformEmuIonFilter = (items) => {
    return items.map(addBaseProperties);
};
